import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useAuth } from '../Providers/AuthProvider';
import { useConfig } from '../Providers/ConfigProvider';
import { GetProductsFeaturesWithQuery } from '../Services/ProductService';
import useDebounce from '../Hooks/useDebounce';
import { getAccessToken } from '../Services/TokenService';
import { useParams } from '../Providers/ParamsProvider';

var qs = require('qs')


export default function useLoadingProducts(pageNumber, setPageNumber, productsFilter, setProductsFilter, activeCategory) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': "Bearer" + " " + getAccessToken(),
    'currentContractorId': Cookies.get('currentContractorId')
  }
  const { productFiltersDebounceTimeout } = useParams()
  const { useDebounceWithStrongValueCheck } = useDebounce()
  const { authState } = useAuth()
  const { api } = useConfig()

  const [loadingProducts, setLoadingProducts] = useState(true)
  const [error, setError] = useState(false)
  const [products, setProducts] = useState([])
  const [productsFeatures, setProductFeatures] = useState([])
  const [hasMore, setHasMore] = useState(false)

  //Tworzymy "opóźnioną" wersję naszego obiektu filtra
  const debouncedFilter = useDebounceWithStrongValueCheck(productsFilter, productFiltersDebounceTimeout)

  useEffect(() => {
    setProducts([])
    setPageNumber(0)
  }, [JSON.stringify(debouncedFilter), authState.custId])

  useEffect(() => {
    if ((!debouncedFilter.SearchingQuery || debouncedFilter.SearchingQuery.trim() === '') && (!activeCategory || activeCategory.catLevel < 3) && (!productsFilter.ProductsFeatures || productsFilter.ProductsFeatures.length === 0)) {
      setProductFeatures([])
      return
    }

    const source = axios.CancelToken.source()
    GetProductsFeaturesWithQuery(api, debouncedFilter, source.token)
      .then(res => {
        setProductFeatures(res.data)
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          console.log(err)
          setProductFeatures([])
        }
      })

    return () => source.cancel()
  }, [JSON.stringify(debouncedFilter)])


  // Główny efekt do pobierania produktów używa opóźnionego filtra
  useEffect(() => {
    setLoadingProducts(true)
    setError(false)

    const source = axios.CancelToken.source()

    api.post('/api/v1/Product', debouncedFilter, { // Używamy `debouncedFilter`
      headers: headers,
      params: {
        pageNumber: pageNumber,
        sortBy: debouncedFilter.SortType,
      },
      paramsSerializer: params => qs.stringify(params),
      cancelToken: source.token
    })
      .then(res => {
        setProducts(prevProducts => {
          return pageNumber === 0 ? res.data : [...prevProducts, ...res.data]
        });
        setHasMore(res.data.length > 0)
      })
      .catch(e => {
        if (axios.isCancel(e)) {
          return
        }
        setError(true)
        console.error(e)
      })
      .finally(() => {
        setLoadingProducts(false)
      })

    return () => {
      source.cancel()
    }

  }, [JSON.stringify(debouncedFilter), pageNumber, authState.custId])


  const handleGetProductsFromSearchingBar = (queryParam, allArticles) => {
    if (!queryParam || queryParam.trim() === '') {
      return
    }

    setPageNumber(0)

    setProductsFilter(prev => ({
      ...prev,
      SearchingQuery: queryParam,
    }))
  }

  return { loadingProducts, error, products, hasMore, productsFeatures, handleGetProductsFromSearchingBar, setProducts }
}
